import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export const kv = () => {
  const section = document.querySelector(".section-kv.is_animate");

  if (!section) return;

  const logo = section.querySelector(".kv__logo");
  const logoMain01 = section.querySelector(".kv__logo-main--01");
  const logoMain02 = section.querySelector(".kv__logo-main--02");
  const logotext = section.querySelector(".kv__logo-text");
  const kvImage = section.querySelectorAll(".kv__image:not(:last-child)");
  const kvShape = section.querySelectorAll(".kv__shape");

  const bgTop = document.querySelectorAll(".bg--top img");

  const tl = gsap.timeline({
    // repeat: -1,
  });

  tl.set(".section-kv .content", {
    opacity: 1,
  })
    .fromTo(
      logoMain01,
      {
        "--p": 0,
      },
      {
        "--p": 1,
        duration: 0.6,
      },
      "<"
    )
    .fromTo(
      logoMain02,
      {
        "--p": 1,
      },
      {
        "--p": 0,
        duration: 0.6,
      },
      "<"
    )
    .from(
      logo,
      {
        opacity: 0,
        duration: 0.4,
        transformOrigin: "center",
      },
      "<25%"
    )
    .from(
      logo,
      {
        scale: 3,
        duration: 1,
        transformOrigin: "center",
      },
      "<"
    )
    .from(logotext.children, {
      opacity: 0,
      transformOrigin: "center",
      stagger: {
        from: "random",
        each: 0.04,
      },
    })
    .from(kvImage, {
      opacity: 0,
      yPercent: 10,
      stagger: {
        from: "random",
        amount: 0.1,
      },
    })
    .from(
      bgTop,
      {
        opacity: 0,
        translateY: "200px",
        duration: 1,
        stagger: {
          each: 0.2,
        },
      },
      "<25%"
    )
    .from(
      kvShape,
      {
        opacity: 0,
        yPercent: 10,
        duration: 1,
        stagger: {
          each: 0.2,
        },
      },
      "<"
    );

  // Fade out the fixed KV while the first subsequent section scrolls
  // into view. CSS padding-top:100dvh on #site-main ensures content
  // is already below the fold before this JS runs, so no flash occurs.
  const nextSection = document.querySelector(
    "#site-main .section:not(.section-kv)"
  );

  if (nextSection) {
    gsap.to(section, {
      opacity: 0,
      ease: "none",
      scrollTrigger: {
        trigger: nextSection,
        start: "top bottom",
        end: "top top",
        scrub: true,
        onLeave: () => {
          section.style.pointerEvents = "none";
          section.style.visibility = "hidden";
        },
        onEnterBack: () => {
          section.style.pointerEvents = "";
          section.style.visibility = "";
        },
      },
    });
  }
};
